import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const LineSmall = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="90px"
        height="4px"
        viewBox="0 0 90 4"
        className={classNames([styles.container, { [className]: className !== null }])}
        xmlSpace="preserve"
    >
        <g>
            <path
                fill={color}
                d="M89,0.8c-0.1,0-0.2-0.2-0.3-0.2c-0.2,0.1-0.2,0-0.3-0.1c-0.1-0.4-0.5-0.1-0.7-0.2c-0.3,0.5-0.6,0-0.8,0
        		c-0.2,0.1-0.4,0.2-0.5,0.1c-0.4-0.2-0.9-0.2-1.3-0.1c-0.3,0-0.4,0-0.6-0.3c-0.1,0.3-0.1,0.5-0.2,0.7c-0.5-0.6-1.1-0.6-1.6-0.3
        		c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.4,0.2c-0.1-0.1-0.1-0.3-0.1-0.3c-0.4,0.1-0.7,0.2-0.9,0.2
        		c-0.5-0.2-0.9-0.1-1.3,0c-0.5,0.1-1,0.3-1.3-0.2c-0.2,0.1-0.4,0.1-0.5,0.1c-0.2,0-0.3-0.1-0.5-0.2c-0.1,0.3-0.3,0.4-0.6,0.3
        		c-0.2-0.1-0.4-0.2-0.6-0.2c-0.3-0.1-0.6-0.1-0.7,0.3c-0.2-0.2-0.4-0.3-0.7-0.4c-0.1,0.2-0.3,0.3-0.4,0.5c-0.1-0.2-0.1-0.3-0.1-0.4
        		c-0.3,0-0.5,0-0.5,0.3c-0.2,0-0.4,0-0.5,0c-0.1,0-0.3,0.1-0.4,0c-0.3-0.1-0.6-0.4-1,0c0,0-0.1,0-0.1,0c-0.2-0.2-0.5,0-0.7-0.1
        		c-0.1,0-0.2-0.1-0.3-0.2c-0.4,0.2-0.4,0.2-1.3,0c0,0.1,0,0.2,0,0.4c-0.6-0.2-1.2-0.4-1.9-0.1c-0.4-0.2-1,0.3-1.3-0.2
        		c-0.2,0.1-0.4,0.2-0.6,0.2c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1,0.2-0.2,0.3-0.2,0.3c-0.3,0-0.6-0.1-0.9-0.1c-0.3,0-0.6,0.1-0.8-0.1
        		c-0.1-0.1-0.2-0.1-0.3-0.1c0,0.2-0.1,0.3-0.1,0.5c-0.3-0.1-0.6-0.2-0.9-0.3c0,0-0.1,0-0.1,0c-0.2,0.1-0.3,0.3-0.5,0.4
        		c0-0.1-0.1-0.2-0.2-0.3c-0.2,0.1-0.4,0.2-0.5,0.1c-0.1,0-0.2-0.2-0.3-0.3c-0.2,0.1-0.4,0.3-0.6,0.2c-0.8-0.1-1.6,0-2.3-0.2
        		c-0.1,0-0.3-0.1-0.3,0c-0.5,0.4-1-0.1-1.5,0.1c-0.4-0.5-0.6-0.1-0.8,0.2c-0.3-0.4-0.6-0.5-1-0.2c-0.1,0-0.2,0.1-0.3,0
        		c-0.4-0.2-0.7,0.1-1,0.4c-0.1-0.2-0.2-0.3-0.2-0.3c-0.5,0.1-0.9-0.1-1.4,0c-0.6,0-1.1,0.3-1.7,0.1c-0.4,0.2-0.7,0-1-0.1
        		c-0.1,0-0.3-0.1-0.4,0c-0.3,0.5-0.6,0.1-0.8,0c-0.5,0.3-0.6,0.3-0.7-0.3c-0.2,0.2-0.3,0.4-0.4,0.6c-0.3-0.4-0.9,0.1-1.2-0.4
        		c-0.1,0.2-0.2,0.4-0.2,0.5c-0.3-0.2-0.5-0.4-0.8-0.6c-0.4,0.4-0.9,0-1.4,0.1c0,0.1,0,0.2,0,0.3c-0.4,0.1-0.7,0-1-0.4
        		c-0.3,0.1-0.4,0.5-0.7,0.3c-0.4-0.3-0.5,0.1-0.7,0.3c-0.2-0.2-0.4-0.7-0.8-0.2c-0.1-0.2-0.2-0.3-0.3-0.5c-0.2,0.1-0.4,0.2-0.6,0.3
        		c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.1-0.5,0.2-0.7,0.3c-0.1-0.1-0.1-0.2-0.2-0.4c-0.1,0.2-0.2,0.3-0.4,0.5c-0.1-0.2-0.1-0.3-0.2-0.5
        		c-0.4,0.4-0.8,0.4-1.2,0.3c-0.5-0.2-1-0.1-1.5,0c-0.2,0-0.5,0-0.7-0.1c-0.3-0.1-0.4,0.3-0.6,0.2c-0.1-0.1-0.2-0.3-0.3-0.4
        		c-0.2,0.2-0.4,0.3-0.6,0.5c-0.3-0.1-0.5-0.3-0.8-0.4C31.1,0.4,31,0.5,31,0.6c-0.1,0-0.3,0-0.4-0.1c-0.2,0-0.3,0-0.5,0
        		c-0.3-0.1-0.6-0.3-0.8,0.1c-0.3-0.2-0.8,0.1-1.1-0.3c-0.1-0.1-0.3-0.1-0.4,0.1c-0.1,0.2-0.2,0.2-0.4,0.2c-0.1,0-0.2,0.1-0.3,0.2
        		C27.1,0.8,27,0.7,27,0.7c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.2,0-0.5-0.1-0.7-0.2c-0.4-0.1-0.6,0.1-0.7,0.5
        		c0,0-0.1,0-0.2,0.1c0-0.2,0-0.4,0-0.7c-0.2,0.1-0.3,0.1-0.5,0.1c-0.1,0-0.3,0.1-0.3,0C24,0.5,24,0.3,23.9,0.1
        		c-0.2,0.2-0.4,0.3-0.6,0.5c-0.2,0-0.4-0.1-0.7-0.1c-0.5-0.2-0.5-0.2-0.8,0.2c-0.2-0.3-0.5-0.4-0.8-0.3c-0.2,0.1-0.4,0.1-0.7,0
        		c-0.3,0-0.6-0.1-0.9,0.1c-0.2,0.1-0.4,0-0.5-0.1c-0.3-0.1-0.4-0.1-0.5,0.2c-0.6,0.2-1.1-0.3-1.7-0.4c0.1,0.2,0.1,0.3,0.1,0.4
        		c-0.5,0.1-0.7-0.1-0.8-0.5c-0.3,0.2-0.4,0.2-0.8,0.2c-0.1,0-0.1,0-0.2,0c-0.2,0.3-0.4,0.2-0.7,0c-0.1-0.1-0.4,0-0.4,0
        		c-0.1,0.3-0.4,0.1-0.4,0.2c-0.3,0.3-0.4-0.1-0.7-0.1c-0.2,0.1-0.5,0.2-0.7,0c-0.1-0.1-0.5,0-0.8,0c-0.4,0.1-0.6-0.1-0.9-0.3
        		c-0.1,0.1-0.1,0.2-0.2,0.4C10,0.4,9.9,0.3,9.7,0.1c-0.2,0.5-0.6,0.4-1,0.3C8.6,0.4,8.4,0.3,8.2,0.3c0.1,0.2,0.1,0.3,0.2,0.5
        		c-0.3-0.1-0.6,0-0.7-0.2c-0.3-0.4-0.5-0.3-0.8,0C6.5,0.7,6.1,0.7,5.7,0.7c-0.2,0-0.3-0.2-0.5-0.4C4.9,0.7,4.7,0.8,4.4,0.7
        		C4,0.5,3.3,0.5,2.9,0.6c-0.3,0.1-0.5,0-0.6-0.3c0,0-0.1-0.1-0.2-0.1c0,0.1,0,0.2,0,0.4C1.7,0.5,1.3,0.4,1,0.4
        		C0.7,0.6,0.6,0.7,0.4,0.8C0.3,1,0,1.2,0,1.4l0.5,0.3c0.3,0,0.8,0.1,1.3,0.2c0-0.1,0-0.2,0-0.4C1.9,1.6,2,1.6,2,1.6
        		C2.1,2,2.3,2,2.6,1.9c0.1,0,0.4-0.1,0.6-0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0C3.6,1.9,3.9,2,4.1,2c0.3,0.1,0.5,0,0.8-0.4
        		c0.2,0.1,0.4,0.4,0.5,0.4c0.4,0,0.8,0,1.1-0.2c0.4-0.2,0.6-0.4,0.9,0C7.6,2.1,7.9,2,8.2,2.1C8.1,1.9,8.1,1.8,8,1.6
        		c0.2,0.1,0.4,0.1,0.6,0.2C9,1.9,9.3,2,9.6,1.5c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.2c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0
        		c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.1-0.2,0.2-0.4c0.3,0.2,0.6,0.4,0.9,0.3c0.3-0.1,0.7-0.2,0.8,0c0.3,0.3,0.5,0.1,0.8,0
        		c0.2-0.1,0.4,0.4,0.7,0.1c0.1-0.1,0.4,0.1,0.5-0.2c0,0,0.1,0,0.1,0c0-0.1-0.1-0.1-0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0.1,0.1,0.1
        		c0,0,0,0.1-0.1,0.1c0.1,0,0.2,0,0.3,0c0.3,0.2,0.5,0.3,0.7,0c0,0,0.1,0,0.2,0c0.4,0,0.5,0,0.8-0.2C16.3,1.9,16.5,2.2,17,2
        		c0-0.1-0.1-0.2-0.1-0.4c0.6,0.1,1.1,0.6,1.7,0.4c0.1-0.3,0.2-0.4,0.5-0.2c0.2,0.1,0.3,0.2,0.5,0.1c0.3-0.2,0.6-0.1,0.9-0.1
        		c0.2,0,0.4,0.1,0.7,0c0.3-0.1,0.6-0.1,0.8,0.3c0.3-0.5,0.3-0.4,0.9-0.2c0.2,0.1,0.5,0.1,0.7,0.1c0.2-0.2,0.4-0.3,0.6-0.5
        		c0.1,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.2,0,0.4-0.1c0.1,0,0.3-0.1,0.5-0.1c0,0.3,0,0.5,0,0.7c0.1,0,0.2,0,0.2-0.1
        		c0.2-0.5,0.3-0.6,0.7-0.5c0.2,0,0.5,0.1,0.7,0.2c0.1,0,0.2-0.1,0.3-0.1c0,0,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2
        		C27.8,2.1,27.9,2,28,2c0.2,0,0.3,0,0.4-0.2c0.1-0.2,0.2-0.2,0.4-0.1C29,2,29.5,1.7,29.9,2c0.2-0.5,0.6-0.2,0.9-0.1
        		c0.2,0,0.3,0,0.5,0c0.1,0,0.3,0,0.4,0.1c0.1-0.1,0.2-0.2,0.3-0.4c0.3,0.1,0.5,0.3,0.8,0.4c0.2-0.2,0.4-0.3,0.6-0.5
        		c0.1,0.1,0.2,0.3,0.3,0.4c0.3,0.1,0.3-0.3,0.6-0.2c0.2,0.1,0.4,0.1,0.7,0.1c0.5-0.2,1-0.3,1.5,0c0.4,0.2,0.8,0.1,1.2-0.3
        		c0.1,0.2,0.1,0.3,0.2,0.5c0.2-0.2,0.3-0.4,0.5-0.5c0.1,0.1,0.2,0.3,0.2,0.4c0.2-0.1,0.5-0.2,0.7-0.4c0,0.1,0.1,0.1,0.2,0.3
        		c0.2-0.1,0.3-0.2,0.6-0.3c0.1,0.1,0.2,0.3,0.3,0.5c0,0,0,0,0,0c-0.1-0.2,0-0.4,0-0.6c0.1,0.1,0.1,0.3,0.2,0.4
        		C40.9,1.6,41,2,41.2,2.2c0.2-0.2,0.2-0.7,0.7-0.3c0.3,0.2,0.5-0.2,0.8-0.3c0.2,0.4,0.6,0.5,1,0.4c0-0.1,0-0.2,0-0.3
        		c0.5-0.1,1,0.3,1.4-0.1c0.3,0.2,0.5,0.4,0.8,0.6C45.9,2,46,1.8,46.1,1.6C46.5,2.1,47,1.5,47.3,2c0.2-0.2,0.3-0.4,0.4-0.7
        		c0.1,0.6,0.1,0.6,0.7,0.3c0.3,0.1,0.5,0.6,0.9,0c0,0,0.2,0,0.4,0c0.3,0.1,0.5,0.3,0.8,0.2c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0
        		c0,0,0.1,0,0.1,0c0.6,0.2,1.2-0.1,1.8-0.1c0.5,0,0.9,0.2,1.4,0c0,0,0.1,0.2,0.2,0.3c0.3-0.3,0.6-0.5,1-0.4c0.1,0,0.2,0,0.3,0
        		c0.4-0.3,0.7-0.2,1,0.2c0.3-0.3,0.5-0.7,0.9-0.2c0.5-0.2,1.1,0.4,1.6-0.1c0.1-0.1,0.2,0,0.3,0c0.8,0.2,1.6,0.1,2.4,0.2
        		c0.2,0,0.4-0.2,0.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0,0.3-0.1,0.6-0.1C63.1,1.8,63.2,2,63.2,2c0.2-0.1,0.3-0.3,0.5-0.4
        		c0,0,0.1,0,0.1,0c0.3,0.1,0.6,0.2,0.9,0.3c0-0.2,0.1-0.3,0.1-0.5c0.1,0,0.2,0.1,0.3,0.1c0.3,0.2,0.6,0.2,0.9,0.1
        		c0.3,0,0.6,0.1,0.9,0.1c0,0,0.1-0.2,0.2-0.3c0.1,0.2,0.2,0.3,0.4,0.4c0.1,0,0.2-0.1,0.3-0.1c0,0-0.1-0.1-0.1-0.1
        		c0.1,0,0.2,0,0.3,0.1c0,0,0.1,0,0.1-0.1c0,0,0,0.1,0.1,0.1c-0.1-0.2,0-0.4,0.3-0.5c0,0.2,0,0.3,0.1,0.5c-0.1,0-0.2,0-0.3,0
        		C68.5,2,69,1.6,69.5,1.8c0.6-0.3,1.3-0.1,1.9,0.1c0-0.1,0-0.3,0-0.4c0.9,0.2,0.9,0.2,1.3,0c0.1,0.1,0.2,0.2,0.4,0.2
        		c0.3,0,0.5-0.1,0.8,0.1c0,0,0.1,0,0.1,0c0.3-0.3,0.7-0.1,1,0c0.1,0,0.3,0,0.4,0c0.2,0,0.4,0,0.5,0c0-0.4,0.2-0.4,0.5-0.3
        		c0,0.1,0.1,0.3,0.2,0.5c0.2-0.2,0.3-0.3,0.4-0.5c0.2,0.1,0.4,0.3,0.7,0.4c0.1-0.4,0.4-0.4,0.7-0.3c0.2,0,0.4,0.1,0.6,0.2
        		c0.3,0.1,0.5,0,0.6-0.3c0.2,0.1,0.4,0.2,0.5,0.2c0.2,0,0.3-0.1,0.6-0.1c0.3,0.5,0.8,0.3,1.3,0.2c0.5-0.1,0.9-0.2,1.4,0
        		c0.2,0.1,0.5-0.1,0.9-0.2c0,0,0.1,0.1,0.1,0.3c0.2-0.1,0.3-0.2,0.4-0.2c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0.1,0.2,0.2,0.3,0.3
        		c0.6-0.3,1.2-0.3,1.7,0.3c0.1-0.3,0.1-0.5,0.2-0.8c0.2,0.3,0.3,0.4,0.6,0.3c0.4-0.1,0.9-0.1,1.3,0.1c0.1,0.1,0.4-0.1,0.5-0.2
        		c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0-0.1,0-0.2c0-0.3-0.1-0.6-0.4-0.7c-0.1,0-0.2-0.2-0.3-0.2C89.2,0.7,89.1,0.8,89,0.8z M3.6,1.5
        		c-0.3,0.1-0.4,0-0.3-0.4C3.4,1.3,3.5,1.4,3.6,1.5z M5.2,1c0,0-0.1-0.1-0.1-0.1c0,0,0.1-0.1,0.1-0.2c0.1,0.1,0.1,0.1,0.2,0.1
        		C5.3,0.9,5.3,1,5.2,1z M7.4,1.5c0,0-0.1,0-0.1,0c0-0.1,0-0.2,0-0.3c0.1,0,0.1,0,0.2,0C7.4,1.3,7.4,1.4,7.4,1.5z M9,1.3
        		C8.9,1,8.9,1,9.2,1C9.1,1.1,9,1.2,9,1.3z M15.1,1.8c0,0-0.1,0.1-0.1,0.1c0-0.1-0.1-0.1-0.1-0.2c0,0,0.1-0.1,0.1-0.2
        		C15,1.7,15.1,1.7,15.1,1.8z M15.9,0.9c-0.1,0-0.1-0.1-0.2-0.1c0,0,0.1-0.1,0.2-0.1c0.1,0.1,0.1,0.1,0.1,0.2
        		C15.9,0.9,15.9,0.9,15.9,0.9z M18.7,1.5c-0.1,0.1-0.1,0.1-0.1,0.2c0,0-0.1-0.1-0.1-0.1c0,0,0.1-0.1,0.1-0.1
        		C18.6,1.4,18.6,1.5,18.7,1.5z M40.4,1.4c-0.3,0.1-0.3,0-0.3-0.4C40.3,1.2,40.4,1.3,40.4,1.4z M51.6,1.2c0.1-0.2,0.2-0.4,0.5-0.3
        		C52,1.1,52,1.3,51.6,1.2z"
            />
            <path fill={color} d="M41.4,2.8c-0.1-0.1-0.1-0.2-0.3-0.4C41.1,2.8,41.2,2.9,41.4,2.8z" />
            <path fill={color} d="M53,2.5c0.3,0.2,0.4-0.1,0.5-0.3C53.2,2.1,53.1,2.3,53,2.5z" />
            <path
                fill={color}
                d="M9.6,3.1c0,0,0.1,0,0.1-0.1c0-0.1,0-0.2,0-0.3C9.6,2.8,9.5,2.9,9.5,2.9C9.5,3,9.6,3,9.6,3.1z"
            />
            <path fill={color} d="M8.8,2.7C8.9,2.6,9,2.5,9.1,2.4C8.7,2.4,8.7,2.4,8.8,2.7z" />
            <path
                fill={color}
                d="M7.1,2.9c0,0,0.1,0,0.1,0c0-0.1,0-0.2,0-0.3c-0.1,0-0.1,0-0.2,0C7.1,2.7,7.1,2.8,7.1,2.9z"
            />
            <path
                fill={color}
                d="M4.8,2.2c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.2-0.1C4.9,2.1,4.8,2.2,4.8,2.2z"
            />
            <path
                fill={color}
                d="M15.8,2.2c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1-0.1,0.1-0.1C16.1,2.1,16,2.1,16,2C15.9,2.1,15.8,2.1,15.8,2.2z"
            />
            <path
                fill={color}
                d="M18.7,2.9c0,0,0.1,0.1,0.1,0.1c0,0,0.1-0.1,0.1-0.2c-0.1,0-0.1-0.1-0.1-0.1C18.7,2.8,18.7,2.9,18.7,2.9z"
            />
            <path
                fill={color}
                d="M21.9,3.9C21.9,3.9,22,4,22,4c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1-0.1-0.3C21.9,3.8,21.9,3.8,21.9,3.9z"
            />
            <path
                fill={color}
                d="M15,3.3c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1-0.1-0.2C15,3,14.9,3.1,14.9,3.1C14.9,3.2,15,3.2,15,3.3z"
            />
            <path
                fill={color}
                d="M14.3,2.9c0-0.1-0.1-0.1-0.1-0.1c0,0-0.1,0.1-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C14.2,3,14.3,3,14.3,2.9z"
            />
            <path
                fill={color}
                d="M15.8,4c0,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.1-0.1,0.2C15.7,3.9,15.7,4,15.8,4z"
            />
        </g>
    </svg>
);

LineSmall.propTypes = propTypes;
LineSmall.defaultProps = defaultProps;

export default LineSmall;
